import { BOOKING_STATUS } from '../../../../constants';

const rescheduleButtonIsDisabled = (notes, masterStatusId) => {
  const allowedBookingStatuses = [
    BOOKING_STATUS.UNALLOCATED,
    BOOKING_STATUS.PENDING,
    BOOKING_STATUS.GARAGE_DECLINED,
  ];
  const bookingStatusNotAllowedForReschedule = !allowedBookingStatuses.includes(masterStatusId);

  const bookingHasRescheduleFlowStartedNote = notes?.find(
    ({ noteType }) => noteType === 'reschedule-casemanager-review'
  );
  return Boolean(bookingStatusNotAllowedForReschedule || bookingHasRescheduleFlowStartedNote);
};

export default rescheduleButtonIsDisabled;
